"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.experimentsSet = exports.uiBodyClassRemove = exports.uiBodyClassAdd = exports.uiScrollToElement = exports.stripeUpdateBillingInfo = exports.stripeUseNewCard = exports.stripeGetSavedCard = exports.stripeSaveCardChange = exports.stripeCreateToken = exports.downloadNoPremiumFeatures = exports.downloadResetAttribution = exports.downloadJumpToLicense = exports.downloadRepurchase = exports.downloadUpsell = exports.downloadResetToLicense = exports.downloadDoUpsell = exports.downloadSelectPurchaseType = exports.downloadPurchase = exports.downloadStartSuccess = exports.downloadStart = exports.downloadShowAuth = exports.downloadRequest = exports.downloadFlowGoBack = exports.downloadSetFlowActive = exports.downloadResetFlow = exports.iconsFetchPurchased = exports.getCurrentUser = exports.fetchSVGData = exports.dismissModal = exports.showModal = exports.MODAL_BG_CLOSE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.saveQueryInfo = saveQueryInfo;
exports.setSearchTerm = setSearchTerm;
exports.fetchAutoCompleteTerms = fetchAutoCompleteTerms;
exports.fetchFeaturedCreators = fetchFeaturedCreators;
exports.fetchFeaturedCollectionMetaData = fetchFeaturedCollectionMetaData;
exports.fetchHeroIcon = fetchHeroIcon;
exports.fetchCollection = fetchCollection;
exports.fetchCollectionIcons = fetchCollectionIcons;
exports.searchCreatorUploads = searchCreatorUploads;
exports.searchCreatorIcons = searchCreatorIcons;
exports.searchCollectionIcons = searchCollectionIcons;
exports.searchTerm = searchTerm;
exports.searchIcons = searchIcons;
exports.fetchViewMoreIcons = fetchViewMoreIcons;
exports.fetchIcons = fetchIcons;
exports.fetchIcon = fetchIcon;
exports.placePluginSVG = placePluginSVG;
exports.saveCleanedSVG = saveCleanedSVG;
exports.setActiveIcon = setActiveIcon;
exports.clearActiveIcon = clearActiveIcon;
exports.getIconMetaData = getIconMetaData;
exports.setColor = setColor;
exports.setSize = setSize;
exports.toggleIconDetail = toggleIconDetail;
exports.fetchRecentIcons = fetchRecentIcons;
exports.fetchBestCollectionIcons = fetchBestCollectionIcons;
exports.fetchFeaturedCollection = fetchFeaturedCollection;
exports.logOut = logOut;
exports.login = login;
exports.signup = signup;
exports.createStripeToken = createStripeToken;
exports.saveCreditCard = saveCreditCard;
exports.upgradeToProAccount = upgradeToProAccount;
exports.getTotalIconCount = getTotalIconCount;
exports.setAdobeAgent = setAdobeAgent;
exports.reportPluginUsage = reportPluginUsage;
exports.setPage = setPage;
exports.setPluginHost = setPluginHost;
exports.placePluginPNGGSuite = placePluginPNGGSuite;
exports.placePluginPDF = placePluginPDF;
exports.placePluginPNG = placePluginPNG;
exports.pluginIcons = pluginIcons;
exports.sendEduApplication = sendEduApplication;
exports.downloadSelectLicense = downloadSelectLicense;
exports.downloadCommitLicense = downloadCommitLicense;
exports.downloadSelectAttribution = downloadSelectAttribution;
exports.downloadCommitAttribution = downloadCommitAttribution;
exports.downloadPurchaseStart = downloadPurchaseStart;
exports.downloadPurchaseEnd = downloadPurchaseEnd;
exports.stripeCreateTokenStart = stripeCreateTokenStart;
exports.stripeCreateTokenSuccess = stripeCreateTokenSuccess;
exports.stripeCreateTokenFailure = stripeCreateTokenFailure;
exports.stripeCardInputChange = stripeCardInputChange;
exports.stripeCardInputError = stripeCardInputError;

var _editor2 = require("./editor");

Object.keys(_editor2).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _editor2[key];
        }
    });
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _api = require("../middleware/api");

var _download = require("../reducers/download");

var _editor3 = require("../reducers/editor");

var _download2 = require("../helpers/download");

var _download3 = _interopRequireDefault(_download2);

var _callApiPromise = require("../helpers/call-api-promise");

var _callApiPromise2 = _interopRequireDefault(_callApiPromise);

var _dispatcher = require("../legacy/dispatcher/dispatcher");

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _defer = require("lodash/defer");

var _defer2 = _interopRequireDefault(_defer);

var _isEmpty = require("lodash/isEmpty");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isEqual = require("lodash/isEqual");

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isRegExp = require("lodash/isRegExp");

var _isRegExp2 = _interopRequireDefault(_isRegExp);

var _reduce = require("lodash/reduce");

var _reduce2 = _interopRequireDefault(_reduce);

var _raven_client = require("../legacy/helpers/raven_client");

var _raven_client2 = _interopRequireDefault(_raven_client);

var editorActions = _interopRequireWildcard(_editor2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Redux action creators live here. Read Redux docs for more information:
 * http://redux.js.org/docs/basics/Actions.html
 */

var actionTypes = require("./actionTypes");

var Schemas = require("../middleware/api").Schemas;

// Fetch actions use API middleware to abstract loading & normalizing data, and handling errors.

// show / dismiss modals

// Message modal sends when dismissed by clicking background
var MODAL_BG_CLOSE = exports.MODAL_BG_CLOSE = "MODAL_BG_CLOSE";

var showModal = exports.showModal = function showModal(e, component, props) {
    return function (dispatch, getState) {
        if (e) e.preventDefault();

        var _getState = getState(),
            modal = _getState.modal;

        var currentModal = modal.component;

        if (currentModal) {
            dispatch(dismissModal());
        }

        return new Promise(function (resolve, reject) {
            props = Object.assign({}, props, {
                onDismiss: resolve
            });

            dispatch(uiBodyClassAdd("modal-activated", "modal-" + component.toLowerCase()));
            dispatch({
                type: actionTypes.SHOW_MODAL,
                component: component,
                props: props
            });
        });
    };
};

var dismissModal = exports.dismissModal = function dismissModal(component, msg) {
    return function (dispatch, getState) {
        var _getState2 = getState(),
            modal = _getState2.modal;

        if (component) {
            var toRemove = ["modal-" + component.toLowerCase()];
            if (modal.all && Object.keys(modal.all).length == 1) {
                toRemove.push("modal-activated");
            }

            var dismissed = modal.all[component];

            if (dismissed) {
                var childProps = dismissed.props;
                if (childProps.onDismiss) {
                    childProps.onDismiss(msg);
                }
            }

            dispatch(uiBodyClassRemove.apply(undefined, toRemove));
        } else {
            dispatch(uiBodyClassRemove(/modal-/));
        }
        dispatch({
            type: actionTypes.DISMISS_MODAL,
            component: component
        });
    };
};

// search

function saveQueryInfo(queryInfo) {
    return {
        queryInfo: queryInfo,
        type: actionTypes.SAVE_QUERY_INFO
    };
}

function setSearchTerm(searchQuery) {
    return {
        query: searchQuery,
        type: actionTypes.SET_SEARCH_QUERY
    };
}

function fetchAutoCompleteTerms(searchQuery) {
    return _defineProperty({
        searchQuery: searchQuery
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_AUTOCOMPLETE_TERMS, actionTypes.FETCH_AUTOCOMPLETE_TERMS_SUCCESS, actionTypes.FETCH_AUTOCOMPLETE_TERMS_FAILURE],
        endpoint: "json_icon_list/autocomplete/?term=" + searchQuery,
        schema: Schemas.SEARCH,
        method: "GET",
        service: "www"
    });
}

// creators

function fetchFeaturedCreators(id) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var limit = 6;

    if (page === 1) {
        limit = 9;
    }
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_FEATURED_CREATORS, actionTypes.FETCH_FEATURED_CREATORS_SUCCESS, actionTypes.FETCH_FEATURED_CREATORS_FAILURE],
        endpoint: "featured/users/?limit=" + limit + "&page=" + page,
        schema: Schemas.CREATOR,
        method: "GET",
        id: id,
        page: page,
        service: "www"
    });
}

function fetchFeaturedCollectionMetaData() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_FEATURED_COLLECTIONS_METADATA, actionTypes.FETCH_FEATURED_COLLECTIONS_METADATA_SUCCESS, actionTypes.FETCH_FEATURED_COLLECTIONS_METADATA_FAILURE],
        endpoint: "featured/collections/?limit=5",
        schema: Schemas.COLLECTIONS,
        method: "GET",
        service: "www"
    });
}

// icons

function fetchHeroIcon(iconId) {
    return _defineProperty({
        icon_id: iconId
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_HERO_ICON, actionTypes.FETCH_HERO_ICON_SUCCESS, actionTypes.FETCH_HERO_ICON_FAILURE],
        endpoint: "json_icon_plugin/" + iconId + "/",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

function fetchCollection(collectionId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var maxIcons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        collectionId: collectionId,
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "json_icon_list/collections/?response=icons_response&id=" + collectionId + "&page=" + page + "&limit=" + maxIcons + "&raw_html=false",
        schema: Schemas.ICONS,
        id: "collectionIcon",
        page: page,
        method: "GET",
        service: "www"
    });
}

function fetchCollectionIcons(collectionId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var maxIcons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        collectionId: collectionId
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS_ICONS, actionTypes.SEARCH_ICONS_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_ICONS_FAILURE],
        endpoint: "json_icon_list/collections/?response=icons_response&id=" + collectionId + "&page=" + page + "&limit=" + maxIcons + "&raw_html=false",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

function searchCreatorUploads(creator) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        apiResponse: true,
        creator: creator
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: creator + "/uploads/json/?page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: "userUploads",
        page: page,
        method: "GET",
        service: "www"
    });
}

function searchCreatorIcons(searchQuery, creator) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 72;

    return _defineProperty({
        searchQuery: searchQuery,
        apiResponse: true,
        creator: creator
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "search/json/icon/?q=" + searchQuery + "&creator=" + creator + "&page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: "userIcons",
        page: page,
        method: "GET",
        service: "www"
    });
}

function searchCollectionIcons(searchQuery, collection) {
    var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 72;

    return _defineProperty({
        searchQuery: searchQuery,
        apiResponse: true,
        collection: collection
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "search/json/icon/?q=" + searchQuery + "&collection=" + collection + "&page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: "collectionIcons",
        page: page,
        method: "GET",
        service: "www"
    });
}

function searchTerm(searchTerm) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        searchTerm: searchTerm,
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "json_icon_list/" + searchTerm + "/?page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: searchTerm,
        page: page,
        method: "GET",
        service: "www"
    });
}

function searchIcons(searchQuery) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        searchQuery: searchQuery,
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "search/json/icon/?q=" + searchQuery + "&page=" + page + "&limit=" + limit + "&raw_html=false",
        schema: Schemas.ICONS,
        id: searchQuery,
        page: page,
        method: "GET",
        service: "www"
    });
}

function fetchViewMoreIcons(iconId) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    return _defineProperty({
        apiResponse: true,
        iconId: iconId
    }, _api.CALL_API, {
        id: iconId,
        types: [actionTypes.FETCH_VIEW_MORE_ICONS, actionTypes.FETCH_VIEW_MORE_ICONS_SUCCESS, actionTypes.FETCH_VIEW_MORE_ICONS_FAILURE],
        endpoint: "search/view-more-this/" + iconId + "/?limit=" + limit + "&offset=" + offset,
        schema: Schemas.ICONS,
        offset: offset,
        method: "GET",
        service: "www"
    });
}

function fetchIcons(searchQuery) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return _defineProperty({
        searchQuery: searchQuery,
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_ICONS, actionTypes.FETCH_ICONS_SUCCESS, actionTypes.FETCH_ICONS_FAILURE],
        endpoint: "plugin_search/?query=" + searchQuery + "&page=" + page,
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

function fetchIcon(iconId) {
    return _defineProperty({
        iconId: iconId
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_ICON, actionTypes.FETCH_ICON_SUCCESS, actionTypes.FETCH_ICON_FAILURE],
        endpoint: "json_icon_plugin/" + iconId + "/",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

var fetchSVGData = exports.fetchSVGData = function fetchSVGData(iconURL, iconId, attribution) {
    return function (dispatch, getState) {
        var _dispatch;

        var _getState3 = getState(),
            icons = _getState3.icons;

        if (attribution && icons.active_icon && icons.active_icon.id == iconId) {
            if (icons.active_icon.loadingRawSVG == attribution) {
                return;
            }
        }
        return dispatch((_dispatch = {
            iconId: iconId
        }, _defineProperty(_dispatch, _api.CALL_API, {
            types: [actionTypes.FETCH_SVG_DATA, actionTypes.FETCH_SVG_DATA_SUCCESS, actionTypes.FETCH_SVG_DATA_FAILURE],
            endpoint: iconURL,
            method: "GET",
            service: "raw",
            binary: iconURL && iconURL.indexOf(".png") >= 0
        }), _defineProperty(_dispatch, _api.DECORATE_ACTIONS, {
            attribution: attribution
        }), _dispatch));
    };
};

function placePluginSVG(icon, selectedColor, imgSize) {
    return _defineProperty({
        icon: icon,
        selectedColor: selectedColor,
        imgSize: imgSize
    }, _api.CALL_API, {
        types: [actionTypes.PLACE_SVG_FROM_ICONLIST, actionTypes.PLACE_SVG_FROM_ICONLIST_SUCCESS, actionTypes.PLACE_SVG_FROM_ICONLIST_FAILURE],
        endpoint: icon.icon_url,
        method: "GET",
        service: "raw"
    });
}

function saveCleanedSVG(cleanedSVGData) {
    return {
        cleanedSVGData: cleanedSVGData,
        type: actionTypes.SAVE_CLEANED_SVG
    };
}

function setActiveIcon(iconId) {
    return {
        icon_id: iconId,
        type: actionTypes.SET_ACTIVE_ICON
    };
}

function clearActiveIcon(iconId) {
    return {
        type: actionTypes.CLEAR_ACTIVE_ICON
    };
}

function getIconMetaData() {
    return {
        type: actionTypes.GET_ICON_META_DATA
    };
}

function setColor(colorPalette) {
    return {
        color: colorPalette,
        type: actionTypes.SET_ICON_COLOR_PALETTE
    };
}

function setSize(imgChoices) {
    return {
        imgChoices: imgChoices,
        type: actionTypes.SET_ICON_SIZE
    };
}

function toggleIconDetail(action, icon) {
    if (action === "show") {
        return {
            type: actionTypes.SHOW_ICON_DETAIL
        };
    } else {
        return {
            type: actionTypes.HIDE_ICON_DETAIL
        };
    }
}

function fetchRecentIcons() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 72;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEARCH_ICONS, actionTypes.SEARCH_ICONS_SUCCESS, actionTypes.SEARCH_ICONS_FAILURE],
        endpoint: "json_icon_list/recent_uploads/?page=" + page + "&limit=" + limit,
        schema: Schemas.ICONS,
        page: page,
        id: "recent",
        method: "GET",
        service: "www"
    });
}

function fetchBestCollectionIcons() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 36;
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_BEST_COLLECTIONS, actionTypes.FETCH_BEST_COLLECTIONS_SUCCESS, actionTypes.FETCH_BEST_COLLECTIONS_FAILURE],
        endpoint: "featured/icons/?page=" + page + "&limit=" + limit,
        schema: Schemas.ICONS,
        page: page,
        id: "browse",
        method: "GET",
        service: "www"
    });
}

function fetchFeaturedCollection(collectionId) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var maxIcons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;

    return _defineProperty({
        collectionId: collectionId
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_FEATURED_COLLECTIONS, actionTypes.FETCH_FEATURED_COLLECTIONS_SUCCESS, actionTypes.FETCH_FEATURED_COLLECTIONS_FAILURE],
        endpoint: "json_icon_list/collections/?response=icons_response&id=" + collectionId + "&page=" + page + "&limit=" + maxIcons + "&raw_html=false",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

// user

function logOut(logoutNextUrl) {
    // hack to get logout redirect working without subclassing logout all
    (0, _jquery2.default)("#logout-form").attr("action", "/logout/?next=" + logoutNextUrl);
    (0, _jquery2.default)("#logout-form").submit();

    return {
        type: actionTypes.LOGOUT_USER
    };
}

var getCurrentUser = exports.getCurrentUser = function getCurrentUser() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.GET_CURRENT_USER, actionTypes.GET_CURRENT_USER_SUCCESS, actionTypes.GET_CURRENT_USER_FAILURE],
        endpoint: "accounts/current-user/",
        schema: Schemas.USER,
        method: "GET",
        data: {},
        service: "www"
    });
};

function login(formData) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.LOGIN, actionTypes.LOGIN_SUCCESS, actionTypes.LOGIN_FAILURE],
        endpoint: "accounts/login/",
        method: "POST",
        formData: formData,
        service: "www"
    });
}

function signup(formData) {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.SIGNUP, actionTypes.SIGNUP_SUCCESS, actionTypes.SIGNUP_FAILURE],
        endpoint: "accounts/signup/",
        method: "POST",
        formData: formData,
        service: "www"
    });
}

function createStripeToken(card, user) {
    // Sends customer's card data to stripe & gets token
    // Relies on stripeToken middleware to make stripe call
    return {
        type: actionTypes.CREATE_STRIPE_TOKEN,
        user: user,
        card: card
    };
}

function saveCreditCard(user, stripeToken, receiptInfo) {
    var data = {};

    if (stripeToken) {
        data.stripe_token = stripeToken;
    }

    if (receiptInfo) {
        data.receipt_info = receiptInfo;
    }

    return _defineProperty({
        userId: user.id
    }, _api.CALL_API, {
        types: [actionTypes.SAVE_CARD, actionTypes.SAVE_CARD_SUCCESS, actionTypes.SAVE_CARD_FAILURE],
        endpoint: user.username + "/card/update/",
        method: "POST",
        data: data,
        schema: Schemas.USER,
        service: "www"
    });
}

function upgradeToProAccount(user, stripeToken) {
    var plan = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "pro-yearly";

    return _defineProperty({
        userId: user.id
    }, _api.CALL_API, {
        types: [actionTypes.UPGRADE_BILLING, actionTypes.UPGRADE_BILLING_SUCCESS, actionTypes.UPGRADE_BILLING_FAILURE],
        endpoint: user.username + "/subscribe/pro/",
        method: "POST",
        formData: "stripe_token=" + stripeToken + "&company_name=&vat=&plan=" + plan + "&coupon=",
        schema: Schemas.USER,
        service: "www"
    });
}

var iconsFetchPurchased = exports.iconsFetchPurchased = function iconsFetchPurchased() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.ICONS_FETCH_PURCHASED, actionTypes.ICONS_FETCH_PURCHASED_SUCCESS, actionTypes.ICONS_FETCH_PURCHASED_FAILURE],
        endpoint: "accounts/purchased_icon_ids/",
        method: "GET",
        service: "www"
    });
};

// Icons

function getTotalIconCount() {
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.FETCH_TOTAL_ICON_COUNT, actionTypes.FETCH_TOTAL_ICON_COUNT_SUCCESS, actionTypes.FETCH_TOTAL_ICON_COUNT_FAILURE],
        endpoint: "count/icons/",
        method: "GET",
        service: "www"
    });
}

// plugin
function setAdobeAgent() {
    return {
        type: actionTypes.SET_ADOBE_AGENT
    };
}

function reportPluginUsage(iconId, host, fileType, hexColor) {
    hexColor = hexColor.replace("#", "");
    return _defineProperty({}, _api.CALL_API, {
        types: [actionTypes.REPORT_PLUGIN_USAGE, actionTypes.REPORT_PLUGIN_USAGE_SUCCESS, actionTypes.REPORT_PLUGIN_USAGE_FAILURE],
        data: {},
        endpoint: "plugin_report/?icon_id=" + iconId + "&host=" + host + "&file_type=" + fileType + "&hexColor=" + hexColor,
        method: "POST",
        service: "www"
    });
}

function setPage(page) {
    return {
        page: page,
        type: actionTypes.SET_PLUGIN_PAGE
    };
}

function setPluginHost(host) {
    return {
        host: host,
        type: actionTypes.SET_PLUGIN_HOST
    };
}

function placePluginPNGGSuite(icon, color, size) {
    return _defineProperty({
        apiResponse: true,
        icon: icon,
        color: color,
        imgSize: size
    }, _api.CALL_API, {
        types: [actionTypes.GET_PNG_URL, actionTypes.GET_PNG_URL_SUCCESS, actionTypes.GET_PNG_URL_FAILURE],
        data: "",
        endpoint: "get_plugin_png_token/" + icon.id + "/",
        method: "GET",
        service: "www"
    });
}

function placePluginPDF(icon, color, size) {
    return _defineProperty({
        apiResponse: true,
        icon: icon,
        imgSize: size
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_PDF_DATA, actionTypes.FETCH_PDF_DATA_SUCCESS, actionTypes.FETCH_PDF_DATA_FAILURE],
        data: "",
        endpoint: "get_plugin_icon/pdf/" + icon.id + "/" + color + "/" + size + "/",
        method: "GET",
        service: "www"
    });
}

function placePluginPNG(assetData, imgSize, host) {
    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_PNG_DATA, actionTypes.FETCH_PNG_DATA_SUCCESS, actionTypes.FETCH_PNG_DATA_FAILURE],
        data: "",
        endpoint: "get_plugin_icon/png/" + assetData.icon_id + "/" + assetData.color + "/" + imgSize + "/",
        method: "GET",
        service: "www"
    });
}

function pluginIcons() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.FETCH_PLUGIN_ICONS, actionTypes.FETCH_PLUGIN_ICONS_SUCCESS, actionTypes.FETCH_PLUGIN_ICONS_FAILURE],
        endpoint: "plugin_icons/" + page + "/",
        schema: Schemas.ICONS,
        method: "GET",
        service: "www"
    });
}

// edu

function sendEduApplication(applicationData) {
    return _defineProperty({
        apiResponse: true
    }, _api.CALL_API, {
        types: [actionTypes.SEND_EDU_APPLICATION, actionTypes.SEND_EDU_APPLICATION_SUCCESS, actionTypes.SEND_EDU_APPLICATION_FAILURE],
        endpoint: "for-edu/apply/",
        method: "POST",
        data: applicationData,
        service: "www"
    });
}

// Downloads
var downloadResetFlow = exports.downloadResetFlow = function downloadResetFlow(preserveEdits) {
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.DOWNLOAD_RESET_FLOW,
            preserveEdits: preserveEdits
        });
    };
};

var downloadSetFlowActive = exports.downloadSetFlowActive = function downloadSetFlowActive(icon, repurchasing) {
    return function (dispatch, getState) {
        var _getState4 = getState(),
            editor = _getState4.editor,
            download = _getState4.download,
            icons = _getState4.icons;

        var cachedSvg = icons[icon.id] && icons[icon.id]["raw_svg_no_attribution"];

        dispatch({
            type: actionTypes.DOWNLOAD_SET_FLOW_ACTIVE,
            icon: icon,
            repurchasing: repurchasing,
            editor: editor,
            cachedSvg: cachedSvg
        });
        dispatch(_extends({
            type: actionTypes.FETCH_HERO_ICON_SUCCESS,
            response: {}
        }, icon));
    };
};

var downloadFlowGoBack = exports.downloadFlowGoBack = function downloadFlowGoBack() {
    return {
        type: actionTypes.DOWNLOAD_FLOW_GO_BACK
    };
};

var downloadRequest = exports.downloadRequest = function downloadRequest() {
    return function (dispatch, getState) {
        var _getState5 = getState(),
            user = _getState5.user,
            icons = _getState5.icons;

        if (!user || (0, _isEmpty2.default)(user) || !user.id) {
            user = false;
            dispatch(downloadShowAuth());
        }

        return dispatch({
            type: actionTypes.DOWNLOAD_REQUEST,
            user: user
        });
    };
};

function downloadSelectLicense(license) {
    return {
        type: actionTypes.DOWNLOAD_SELECT_LICENSE,
        license: license
    };
}

function downloadCommitLicense() {
    return {
        type: actionTypes.DOWNLOAD_COMMIT_LICENSE
    };
}

function downloadSelectAttribution(attributionType) {
    return {
        type: actionTypes.DOWNLOAD_SELECT_ATTRIBUTION,
        attributionType: attributionType
    };
}
function downloadCommitAttribution() {
    return {
        type: actionTypes.DOWNLOAD_COMMIT_ATTRIBUTION
    };
}

var downloadShowAuth = exports.downloadShowAuth = function downloadShowAuth() {
    _dispatcher2.default.dispatch({
        actionType: "loginRequired"
    });

    return {
        type: "DOWNLOAD_SHOW_AUTH"
    };
};

var downloadStart = exports.downloadStart = function downloadStart(format) {
    return function (dispatch, getState) {
        var _getState6 = getState(),
            download = _getState6.download,
            editor = _getState6.editor;

        var pendingDownload = download.pendingDownload,
            processing = download.processing,
            isPremiumUser = download.isPremiumUser,
            hasPurchased = download.hasPurchased,
            iconBaseLicense = download.iconBaseLicense;

        if (processing) {

            return;
        }

        if (!format) {
            return dispatch({
                type: actionTypes.DOWNLOAD_START_FAILURE,
                error: "Please select a format to download."
            });
        }

        var transforms = editor.transforms;
        var selectedColor = transforms.color;

        var imgColor = void 0;
        if (selectedColor) {
            imgColor = selectedColor;
        }

        var data = {
            icon_id: pendingDownload.id,
            img_type: format
        };

        var isPublicDomain = iconBaseLicense == _download.licenses.PUBLIC_DOMAIN;

        var downloadType = isPremiumUser ? "Pro" : "Public Domain";
        if (hasPurchased) {
            downloadType = "Royalty Free";
        }

        if (isPremiumUser || hasPurchased || isPublicDomain) {
            var _getState7 = getState(),
                _editor = _getState7.editor;

            var canDoLegacy = (0, _isEmpty2.default)(_editor.changed) || (0, _isEqual2.default)(_editor.changed, _editor3.LegacyModeChanged);

            if (!canDoLegacy) {
                var fileName = makeIconFilename(pendingDownload, null, format);
                dispatch({ type: actionTypes.DOWNLOAD_START, fileType: format });

                var previousExportSize = void 0;
                if (format == "svg") {
                    // Re-render svg at 100x100
                    previousExportSize = transforms.exportSize;
                    dispatch(editorActions.editorTransform("EXPORT_SIZE", 100));
                }

                (0, _defer2.default)(function () {
                    dispatch(editorActions.editorExport(format, fileName)).then(function () {
                        return dispatch({
                            type: actionTypes.DOWNLOAD_COMPLETE_SUCCESS,
                            fileType: format,
                            downloadType: "edited." + downloadType
                        });
                    }).catch(function (error) {
                        console.warn(error);
                        dispatch({
                            type: actionTypes.DOWNLOAD_COMPLETE_FAILURE,
                            fileType: format,
                            error: error
                        });
                    }).then(function () {
                        if (previousExportSize) {
                            dispatch(editorActions.editorTransform("EXPORT_SIZE", previousExportSize));
                        }
                    });
                });
                return;
            } else {
                var _imgColor = "000000";
                if (selectedColor) {
                    _imgColor = selectedColor.split("#")[1];
                }

                data.img_color = _imgColor;
                var fileUrl = "/icon/" + pendingDownload.id + "/download/color/" + data.img_color + "/" + data.img_type + "/";
                return dispatch(downloadStartSuccess({
                    fileType: format,
                    downloadType: downloadType,
                    imgColor: _imgColor,
                    response: {
                        download: fileUrl
                    }
                }));
            }
        }

        downloadType = "Creative Commons";
        return dispatch((0, _callApiPromise2.default)({
            types: [actionTypes.DOWNLOAD_START, downloadStartSuccess, actionTypes.DOWNLOAD_START_FAILURE],
            endpoint: "/icon/" + pendingDownload.id + "/download/",
            method: "POST",
            data: data,
            actionPayload: {
                downloadType: downloadType,
                fileType: format,
                icon: pendingDownload.id
            }
        })).catch(function (error) {
            var code = error && error.status || "";
            _raven_client2.default.captureMessage(downloadType + " Download failed " + code, {
                extra: {
                    iconId: pendingDownload.id,
                    data: data,
                    error: JSON.stringify(error)
                }
            });
        });
    };
};

var makeIconFilename = function makeIconFilename(icon, color, fileType) {
    var name = icon.name,
        id = icon.id,
        term = icon.term;


    var fileName = "noun_" + (name || term || "") + "_" + id;
    if (color) {
        fileName = fileName + "_" + color;
    }
    return fileName + "." + fileType;
};

var downloadStartSuccess = exports.downloadStartSuccess = function downloadStartSuccess(_ref32) {
    var response = _ref32.response,
        downloadType = _ref32.downloadType,
        imgColor = _ref32.imgColor,
        fileType = _ref32.fileType;
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.DOWNLOAD_START_SUCCESS,
            fileType: fileType,
            downloadType: downloadType,
            imgColor: imgColor,
            response: response
        });

        var downloadUrl = response.download;

        var _getState8 = getState(),
            download = _getState8.download;

        var pendingDownload = download.pendingDownload;
        var id = pendingDownload.id;


        var fileName = makeIconFilename(pendingDownload, imgColor, fileType);

        var error = null;
        var finished = (0, _download3.default)(downloadUrl, fileName);
        if (finished.then) {
            return finished.then(function () {
                dispatch({
                    type: actionTypes.DOWNLOAD_COMPLETE_SUCCESS,
                    downloadType: downloadType,
                    fileType: fileType,
                    icon: id
                });
            }).catch(function (error) {
                dispatch({
                    type: actionTypes.DOWNLOAD_COMPLETE_FAILURE,
                    error: error,
                    downloadType: downloadType,
                    fileType: fileType,
                    icon: id
                });
                var code = error && error.status || "";
                var message = downloadType + " Download failed " + code;
                _raven_client2.default.captureMessage(message, {
                    extra: {
                        iconId: id,
                        fileName: fileName,
                        downloadUrl: downloadUrl,
                        error: error
                    }
                });
            });
        } else {
            dispatch({
                type: actionTypes.DOWNLOAD_COMPLETE_SUCCESS,
                downloadType: downloadType,
                fileType: fileType,
                icon: id
            });
        }
    };
};

var downloadPurchase = exports.downloadPurchase = function downloadPurchase(stripeApi) {
    return function (dispatch, getState) {
        var _getState9 = getState(),
            stripe = _getState9.stripe,
            download = _getState9.download,
            user = _getState9.user;

        var pendingDownload = download.pendingDownload,
            processing = download.processing;

        if (processing) {
            return;
        }

        var iconId = pendingDownload.id;
        var stripeToken = stripe.stripeToken,
            currentPurchase = stripe.currentPurchase,
            saveCard = stripe.saveCard,
            savedCard = stripe.savedCard,
            useNewCard = stripe.useNewCard,
            billingInfo = stripe.billingInfo;


        if (!currentPurchase) {
            return dispatch(downloadPurchaseEnd("Please select a license."));
        }

        var isAlaCarte = !currentPurchase.period;
        var isSubscription = !!currentPurchase.period;

        var getToken = void 0;
        if (savedCard && !useNewCard) {
            getToken = Promise.resolve();
        } else {
            if (!stripeApi) {
                return dispatch(downloadPurchaseEnd("Please enter a payment method."));
            }
            getToken = dispatch(stripeCreateToken(stripeApi));
        }

        var didUpdateSavedCard = void 0;
        dispatch(downloadPurchaseStart());
        return getToken.then(function (stripeResponse) {
            if (stripeResponse) {
                var token = stripeResponse.token;

                return token.id;
            }
        }).then(function (token) {
            var updateBillingInfo = void 0;
            if (billingInfo) {
                updateBillingInfo = billingInfo;
            }

            var updateToken = void 0;
            if (token && isAlaCarte && saveCard || isSubscription) {
                updateToken = token;
            }

            if (updateToken || updateBillingInfo) {
                var endpoint = "/" + user.username + "/card/update/";
                var data = {
                    stripe_token: updateToken,
                    receipt_info: updateBillingInfo
                };

                return dispatch((0, _callApiPromise2.default)({
                    method: "post",
                    types: [actionTypes.SAVE_CARD, actionTypes.SAVE_CARD_SUCCESS, actionTypes.SAVE_CARD_FAILURE],
                    data: data,
                    endpoint: endpoint
                })).then(function (response) {
                    // Only pass the token through if not saving card
                    if (!updateToken) {
                        return token;
                    } else {
                        didUpdateSavedCard = true;
                    }
                }).catch(function (error) {
                    // /card/update returns weird errors
                    return Promise.reject("Something went wrong trying to save your card, you have not been charged.");
                });
            }
            return token;
        }).then(function (token) {
            var data = {};

            if (token) {
                data.stripe_token = token;
            }

            var endpoint = void 0;
            if (isAlaCarte) {
                endpoint = "/icon/" + iconId + "/purchase/";
            } else {
                data.plan = currentPurchase.type + "-" + currentPurchase.period;
                endpoint = "/" + user.username + "/subscribe/pro/";
            }

            return dispatch((0, _callApiPromise2.default)({
                endpoint: endpoint,
                data: data,
                method: "post",
                types: [actionTypes.DOWNLOAD_PURCHASE, actionTypes.DOWNLOAD_PURCHASE_SUCCESS, actionTypes.DOWNLOAD_PURCHASE_FAILURE],
                actionPayload: {
                    purchase: currentPurchase
                }
            }));
        }).then(function () {
            dispatch(downloadPurchaseEnd());
        }).catch(function (error) {
            if (error) {
                if (error.statusText) {
                    error = error.statusText;
                } else if (error.error && error.error.message) {
                    error = error.error.message;
                }
            }

            dispatch(downloadPurchaseEnd(error));
        }).then(function () {
            if (didUpdateSavedCard) {
                return dispatch(stripeGetSavedCard());
            }
        });
    };
};

var downloadSelectPurchaseType = exports.downloadSelectPurchaseType = function downloadSelectPurchaseType(purchaseTypeKey) {
    return function (dispatch, getState) {
        var _getState10 = getState(),
            download = _getState10.download,
            stripe = _getState10.stripe;

        if (download.processing || stripe.processing) {
            return;
        }

        return dispatch({
            type: actionTypes.DOWNLOAD_SELECT_PURCHASE_TYPE,
            purchaseTypeKey: purchaseTypeKey
        });
    };
};

var downloadDoUpsell = exports.downloadDoUpsell = function downloadDoUpsell() {
    return function (dispatch, getState) {
        var pendingDownload = getState().download.pendingDownload;

        dispatch(downloadUpsell(pendingDownload));
    };
};

var downloadResetToLicense = exports.downloadResetToLicense = function downloadResetToLicense(icon, license, preserveEdits) {
    return function (dispatch, getState) {
        dispatch(downloadResetFlow(preserveEdits));
        dispatch(downloadSetFlowActive(icon));
        dispatch(downloadRequest());
        dispatch(downloadSelectLicense(license));
        dispatch(downloadCommitLicense());
    };
};
var downloadUpsell = exports.downloadUpsell = function downloadUpsell(icon) {
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.DOWNLOAD_UPSELL_ACCEPTED
        });
        dispatch(downloadResetToLicense(icon, _download.licenses.ROYALTY_FREE, true));
    };
};

var downloadRepurchase = exports.downloadRepurchase = function downloadRepurchase(icon) {
    return function (dispatch, getState) {
        dispatch(downloadResetFlow());
        dispatch({
            type: actionTypes.DOWNLOAD_REPURCHASE
        });
        dispatch(downloadSetFlowActive(icon, true));
        dispatch(downloadRequest());
        dispatch(downloadSelectLicense(_download.licenses.ROYALTY_FREE));
        dispatch(downloadCommitLicense());
        dispatch(downloadSelectPurchaseType("alacarte"));
    };
};

var downloadJumpToLicense = exports.downloadJumpToLicense = function downloadJumpToLicense(license) {
    return function (dispatch, getState) {
        var _getState11 = getState(),
            download = _getState11.download;

        if (download.processing) {
            return;
        }

        var usingPremiumFeatures = download.usingPremiumFeatures;


        var icon = download.pendingDownload;

        dispatch({
            type: actionTypes.DOWNLOAD_JUMP_TO_LICENSE,
            license: license
        });

        dispatch(downloadResetToLicense(icon, license, true));
    };
};

var downloadResetAttribution = exports.downloadResetAttribution = function downloadResetAttribution() {
    return function (dispatch, getState) {
        var _getState12 = getState(),
            download = _getState12.download;

        if (download.processing) {
            return;
        }

        var icon = download.pendingDownload;

        dispatch(downloadResetToLicense(icon, _download.licenses.CREATIVE_COMMONS));
    };
};

var downloadNoPremiumFeatures = exports.downloadNoPremiumFeatures = function downloadNoPremiumFeatures(icon) {
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.DOWNLOAD_UPSELL_REJECTED
        });
        dispatch(editorActions.editorReset());
    };
};

function downloadPurchaseStart() {
    return {
        type: actionTypes.DOWNLOAD_PURCHASE_START
    };
}

function downloadPurchaseEnd(error) {
    return {
        type: actionTypes.DOWNLOAD_PURCHASE_END,
        error: error
    };
}

// Stripe for icon purchases

function stripeCreateTokenStart() {
    return {
        type: actionTypes.STRIPE_CREATE_TOKEN
    };
}

function stripeCreateTokenSuccess(payload) {
    return {
        type: actionTypes.STRIPE_CREATE_TOKEN_SUCCESS,
        payload: payload
    };
}

function stripeCreateTokenFailure(error) {
    return {
        type: actionTypes.STRIPE_CREATE_TOKEN_FAILURE,
        error: error
    };
}

var stripeCreateToken = exports.stripeCreateToken = function stripeCreateToken(stripe) {
    return function (dispatch) {
        dispatch(stripeCreateTokenStart());
        return stripe.createToken().then(function (payload) {
            if (payload.error) {
                return Promise.reject(payload.error);
            }
            dispatch(stripeCreateTokenSuccess(payload));
            return payload;
        }).catch(function (error) {
            dispatch(stripeCreateTokenFailure(error));
            return Promise.reject(error);
        });
    };
};

function stripeCardInputChange() {
    return {
        type: actionTypes.STRIPE_CARD_INPUT_CHANGE
    };
}

function stripeCardInputError(error) {
    if (error && error.message) {
        error = error.message;
    }

    return {
        type: actionTypes.STRIPE_CARD_INPUT_ERROR,
        error: error
    };
}

var stripeSaveCardChange = exports.stripeSaveCardChange = function stripeSaveCardChange(value) {
    return function (dispatch, getState) {
        var _getState13 = getState(),
            download = _getState13.download,
            stripe = _getState13.stripe;

        if (download.processing || stripe.processing) {
            return;
        }

        return dispatch({
            type: actionTypes.STRIPE_SAVE_CARD_CHANGE,
            value: value
        });
    };
};

var stripeGetSavedCard = exports.stripeGetSavedCard = function stripeGetSavedCard() {
    return function (dispatch) {
        var endpoint = "/get/customer/";

        return dispatch((0, _callApiPromise2.default)({
            types: [actionTypes.STRIPE_GET_SAVED_CARD, actionTypes.STRIPE_GET_SAVED_CARD_SUCCESS, actionTypes.STRIPE_GET_SAVED_CARD_FAILURE],
            endpoint: endpoint,
            method: "GET"
        }));
    };
};

var stripeUseNewCard = exports.stripeUseNewCard = function stripeUseNewCard() {
    return function (dispatch, getState) {
        var _getState14 = getState(),
            download = _getState14.download,
            stripe = _getState14.stripe;

        if (download.processing || stripe.processing) {
            return;
        }

        return dispatch({
            type: actionTypes.STRIPE_USE_NEW_CARD
        });
    };
};

var stripeUpdateBillingInfo = exports.stripeUpdateBillingInfo = function stripeUpdateBillingInfo(value) {
    return function (dispatch, getState) {
        var _getState15 = getState(),
            download = _getState15.download,
            stripe = _getState15.stripe;

        if (download.processing || stripe.processing) {
            return;
        }

        return dispatch({
            type: actionTypes.STRIPE_UPDATE_BILLING_INFO,
            value: value
        });
    };
};

// UI
var uiScrollToElement = exports.uiScrollToElement = function uiScrollToElement(el) {
    if (el) {
        var scrollToEl = (0, _jquery2.default)(el);
        if (scrollToEl.length) {
            var contentOffset = (0, _jquery2.default)("#main-content").offset().top + 1;
            var scrollTo = scrollToEl.offset().top - contentOffset;

            (0, _jquery2.default)("html,body").scrollTop(scrollTo);
        } else {
            console.warn("scroll to element not found", el);
        }
    }

    return {
        type: actionTypes.UI_SCROLL_TO_ELEMENT,
        element: el && (el.id || el.getAttribute("class"))
    };
};

var uiBodyClassAdd = exports.uiBodyClassAdd = function uiBodyClassAdd() {
    for (var _len = arguments.length, classes = Array(_len), _key = 0; _key < _len; _key++) {
        classes[_key] = arguments[_key];
    }

    if (classes && classes.length) {
        var _global$document$body;

        (_global$document$body = global.document.body.classList).add.apply(_global$document$body, classes);
    }
    return {
        type: actionTypes.UI_BODY_CLASS_ADD,
        classes: classes
    };
};

var uiBodyClassRemove = exports.uiBodyClassRemove = function uiBodyClassRemove() {
    for (var _len2 = arguments.length, classes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        classes[_key2] = arguments[_key2];
    }

    var toRemove = [];
    if (classes && classes.length == 1 && (0, _isRegExp2.default)(classes[0])) {
        var needle = classes[0];

        var classList = global.document.body.classList;

        if (!classList.forEach) {
            classList = [].slice.call(classList);
        }

        classList.forEach(function (cl) {
            if (needle.test(cl)) {
                toRemove.push(cl);
            }
        });
    } else {
        toRemove = classes;
    }

    if (toRemove.length) {
        var _global$document$body2;

        (_global$document$body2 = global.document.body.classList).remove.apply(_global$document$body2, _toConsumableArray(toRemove));
    }

    return {
        type: actionTypes.UI_BODY_CLASS_REMOVE,
        toRemove: toRemove
    };
};

var experimentsSet = exports.experimentsSet = function experimentsSet(experiments) {
    return {
        type: actionTypes.EXPERIMENTS_SET,
        experiments: experiments
    };
};

// Editor